<template>
    <section class="min-vh-100 d-flex">
        <div class="row g-0 overflow-hidden w-100 shadow rounded">
            <div class="col-lg-5 col-md-12 col-sm-12 signup-image">
                <div class="image"></div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12  container-3">
                <div class="mx-auto ">
                    <div class="d-flex flex-column content-login align-items-flex-start px-5 mx-5">
                        <div class="info">
                            <router-link to="/">
                                <img src="../../assets/images/home/sign-up-logo.svg" alt="" class="img-fluid">
                            </router-link>
                            <div class="mt-4">
                                <h1> {{ $t('join-heading') }} </h1>
                            </div>
                        </div>
                    </div>
                    <form id="formAuthentication" class="mx-5 d-flex flex-column gap-4 mt-4" @submit.prevent="JoinForm" novalidate>
                        <!--------------Select Gender------------------------------>
                        <div class="row ">
                            <div class="col mb-24 ">
                                <span >{{ $t('teaching_experience') }}</span>
                                <div class="position-relative">
                                    <select id="genderSelect" class="w-100" v-model="teaching_history">
                                        <option value="" disabled selected> {{ $t('select_option') }} </option>
                                        <option value="In person, informally"> {{ $t('informal') }} </option>
                                        <option value="In person, professionally">{{ $t('professional') }}</option>
                                        <option value="online"> {{ $t('online') }} </option>
                                        <option value="other"> {{ $t('other') }} </option>
                                    </select>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.teaching_history.$error">
                                    {{ v$.teaching_history.$errors[0].$message }}
                                </span>
                            </div>
                        </div>     
                        <!--------------Select Gender 1------------------------------>
                        <div class="row">
                            <div class="col mb-24 ">
                                <span > {{ $t('video_experience') }} </span>
                                <div class="position-relative">
                                    <select id="genderSelect1" class="w-100" v-model="video_recording_experience">
                                        <option value="" disabled selected> {{ $t('select_option') }} </option>
                                        <option value="I'm a beginner"> {{ $t('beginner') }} </option>
                                        <option value="I have some knowledge"> {{ $t('some_knowledge') }} </option>
                                        <option value="I'm Experienced"> {{ $t('experienced') }} </option>
                                        <option value="I have Videos ready to upload"> {{ $t('ready_to_upload') }} </option>
                                    </select>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.video_recording_experience.$error">
                                    {{ v$.video_recording_experience.$errors[0].$message }}
                                </span>
                            </div>
                        </div>       
                        <!--------------Select Gender2------------------------------>
                        <div class="row ">
                            <div class="col mb-24 ">
                                <span > {{ $t('audience') }} </span>
                                <div class="position-relative">
                                    <select id="genderSelect2" class="w-100" v-model="has_audience_before">
                                        <option value="" disabled selected> {{ $t('select_option') }} </option>
                                        <option value="Not at the moment"> {{ $t('none') }} </option>
                                        <option value="I have a small following"> {{ $t('small_following') }} </option>
                                        <option value="i have a sizeable following"> {{ $t('sizeable_following') }} </option>
                                    </select>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.has_audience_before.$error">
                                    {{ v$.has_audience_before.$errors[0].$message }}
                                </span>
                            </div>
                        </div>   

                        <!---Error Message-->
                        <div class="alert alert-danger mb-3" v-if="serverError">
                            {{ serverError }}
                        </div>
                        <!---------------------------->
                        <button class="main-button d-grid w-100 mb-24 mt-5 fw-500" type="submit">
                            {{ $t('send_button') }}
                        </button>
                    </form>

                </div>
            </div>
        </div>
    </section>

    <SuccessPopup :isSuccessPopupVisible="successPopupVisible" :isForm="true" @close-popup="handlePopupClose" />
</template>

<script>
import useVuelidate from '@vuelidate/core';
import SuccessPopup from '../common/SuccessPopup.vue';
import { required, helpers } from '@vuelidate/validators'
import { mapGetters } from 'vuex';
import { TeacherSignUp } from '@/Services/api/AuthService';
export default {
    components: { SuccessPopup },
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            teaching_history: "",
            video_recording_experience: "",
            has_audience_before: "",
            dropdownOpen: false,  
            formSubmitted: false,
            serverError: "",
            successPopupVisible: false
        }
    },
    validations() {
        return {
            teaching_history: { required: helpers.withMessage(() => this.$t('validations.required'), required) },
            video_recording_experience: { required: helpers.withMessage(() => this.$t('validations.required'), required) },
            has_audience_before: { required: helpers.withMessage(() => this.$t('validations.required'), required) },
        }
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
    },
    methods: {
        //close pop up
        handlePopupClose() {
            this.successPopupVisible = false
        },
        //Submit Sign up Form
        async JoinForm() {
            this.v$.$validate();
            this.formSubmitted = true;

            if (!this.v$.$error) {
                const formData = {
                    teaching_history: this.teaching_history,
                    video_recording_experience: this.video_recording_experience,
                    has_audience_before: this.has_audience_before,
                }
                try {
                    const response = await TeacherSignUp(formData);
                    if (!response.success) {
                        this.serverError = "";
                        this.successPopupVisible = true;
                        this.resetForm();
                    }
                } catch (error) {
                    this.serverError = error.message;
                }

            }
        },
        resetForm() {
            this.teaching_history = '';
            this.video_recording_experience = '';
            this.has_audience_before = '';
            this.v$.$reset();
        }
    },

}
</script>
<style lang="scss" scoped>
$font-family: Almarai;
$font-weight-normal: 400;
$font-weight-bold: 700;
$color-gray: #c7c7c7;
$color-black: #000;
$color-primary: #206387;
$color-facebook: #3D5A98;
$color-linkedin: #0076B2;
$color-email : #263238;
$color-white : rgba(255, 255, 255, 1);

/******************* */
* {
    &:lang(en) {
        font-family: "poppins", sans-serif;
    }

    &:lang(ar) {
        font-family: "Almarai", serif;
    }
}

.form-group {
    margin: 15px 0;
}

#genderSelect,#genderSelect1,#genderSelect2{
    border-bottom: 1px solid #0F1030;
    padding: 15px 0;
    color: #47494a;

    &:focus-visible {
        outline: none;
    }
}

/****************/
.custom-select {
    position: relative;
    width: 100%;
    margin-top: 25px;
}

.selected {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    padding: 18px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
}

.options {
    position: absolute;
    z-index: 10;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

.option {
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 10px;
    cursor: pointer;
}

.option:hover {
    background-color: #f0f0f0;
}

.country-flag {
    width: 20px;
    height: auto;
    margin-right: 8px;
}

/*********************/
.image {
    background-image: url("../../assets/images/home/sign-instructor21.png");
    //background-image: url("../../assets/images/home/sign-up.png");
    background-position: center center;
    background-size: cover;
    height: 100%;
}

a {
    cursor: pointer;
}

.content-login {
    .info {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        h3,
        p {
            color: var(--Dark-blue, #0F1030);
        }

        h3 {
            margin-top: 24px;
            margin-bottom: 12px;
            font-size: 30px;
            font-weight: 500;
        }

        p {
            font-size: 16px;

            span {
                display: inline-block;
                margin-bottom: 8px;
            }
        }
    }
}

input:focus,
input:focus-visible {
    outline: none;
    border: none !important;
}

h1 {
    color: #000;
    font-size: 25px;
    font-weight: 700;
    margin-bottom: 29px;
}

/**********************************/
.user-first,
.user-last {
    top: 50%;
}

.user-first,
.user-last,
.user-first-2 {
    position: absolute;
    transform: translateY(-50%);

    &:lang(ar) {
        right: 0px;
    }

    &:lang(en) {
        left: 0px;
    }
}

.user-first-2 {
    top: 57%;
}

label[for="idCard"]~.fa-id-card {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
}

.fa-id-card {
    font-size: 21px;
    color: #d3d4d4;
}

/********************************/
input[type="email"],
input[type="text"],
input[type="password"],
input[type="tel"] {
    font-size: 18px;

    &:lang(ar) {
        padding: 5px 20px 0 0;
        text-align: right;
    }

    &:lang(en) {
        padding: 5px 0 0 20px;
        text-align: left;
    }

    border:none;
    background: #f8f9fa;

    &::placeholder {
        color: #0F1030;
        font-size: 12px;
        font-weight: $font-weight-normal;
        padding: 0px 5px;
    }
}

input[type="password"] {
    padding: 5px 35px 5px 35px;
}

input[type="text"] {
    width: inherit;
}

.phone-container {
    border: 1px solid #E0E0E0;
}

.label-link {
    color: #0076B2;
    font-size: 14px;
}

/* Move the select icon to the left */
.form-select {
    &:lang(ar) {
        padding-right: 35px;
        border-left: 1px solid $color-gray;
        background-position: left 0.75rem center;
    }

    &:lang(en) {
        padding-left: 35px;
        border-right: 1px solid $color-gray;
        background-position: right 0.75rem center;
    }

    width: 150px;
    font-size: 18px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // background-image:url(../../../../../assets/images/down-arrow.svg);
    color: $color-gray;
    background-repeat: no-repeat;
    background-size: 1em 1em;
    padding-left: 2.5em;
    border-radius: 0;

    &:focus {
        box-shadow: none !important;
        border-left: 2px solid blue;
    }
}

input[type=text] {
    border: none !important;

    &:focus {
        border: none !important;
    }
}

/*************New Edits**************************************/
::placeholder {
    padding: 10px;
}

.form-control:focus-within {
    border-color: #206387;

    ::placeholder {
        opacity: 0;
    }
}

.mb-24 {
    margin-bottom: 34px;
}

.form-control {
    border: none !important;
    border-bottom: 1px solid #0F1030 !important;
    border-radius: 0 !important;

    &:lang(en) {
        padding-left: 0 !important;
    }

    &:lang(ar) {
        padding-right: 0 !important;
    }
}

input {
    border: none !important;
}

.input-group-text-fa {
    position: absolute;
    top: 11px;
    display: inline-flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;

    &:lang(ar) {
        left: 0;
    }

    &:lang(en) {
        right: 0;
    }

    .fa {
        color: #a6a6a6;
        font-size: 16px;
    }
}

.form-check-input:checked,
.form-check-input[type=checkbox]:indeterminate {
    background-color: $color-facebook;
    border-color: $color-facebook;
}

button[type="submit"] {
    font-size: 20px;
    font-weight: $font-weight-bold;
}

.signIn {
    gap: 5px;

    span {
        color: $color-black;
        font-weight: $font-weight-normal;
        font-size: 14px;
    }

    a {
        font-weight: $font-weight-normal;
        font-size: 14px;
        color: #2ea2ce;
    }
}

@media screen and (max-width: 992px) {
    .image {
        display: none;
    }
}
</style>